import { createMessageTemplatesService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const MessageTemplatesService = createMessageTemplatesService(authorizedHttpClient, import.meta.env.VITE_API_URL)
